var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10666 7.53237C6.03999 7.5257 5.95999 7.5257 5.88666 7.53237C4.29999 7.47903 3.03999 6.17903 3.03999 4.57903C3.03999 2.9457 4.35999 1.61903 5.99999 1.61903C7.63333 1.61903 8.95999 2.9457 8.95999 4.57903C8.95333 6.17903 7.69333 7.47903 6.10666 7.53237Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.94 2.95238C12.2333 2.95238 13.2733 3.99904 13.2733 5.28571C13.2733 6.54571 12.2733 7.57238 11.0267 7.61904C10.9733 7.61238 10.9133 7.61238 10.8533 7.61904",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77334 9.99236C1.16001 11.0724 1.16001 12.8324 2.77334 13.9057C4.60667 15.1324 7.61334 15.1324 9.44667 13.9057C11.06 12.8257 11.06 11.0657 9.44667 9.99236C7.62001 8.77236 4.61334 8.77236 2.77334 9.99236Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2267 13.619C12.7067 13.519 13.16 13.3257 13.5333 13.039C14.5733 12.259 14.5733 10.9724 13.5333 10.1924C13.1667 9.91238 12.72 9.72572 12.2467 9.61905",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.7cf7eae904c5adcec5e92189697a701c.svg";
export { ForwardRef as ReactComponent };